<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  {{news.textParams[0]}}
  {{$t('news.template.proposal.committeeDecision.p1')}}
  <router-link :to="{name: 'forum', params: {id: 1}}"
  >
    {{$t('news.template.proposal.committeeDecision.p2')}}
  </router-link>
  {{$t('news.template.proposal.committeeDecision.p3')}}
  <router-link :to="{name: 'ProposalView', params: {id: news.textParams[2]}}">
    {{news.textParams[3]}}
  </router-link>
</div>
</template>
